import React, { useEffect, useState } from "react";
import "@google/model-viewer";

type ModelViewerProps = {
  modelPath: string;
  rotationY?: number;
  iosSrc?: string | null;
  setLoading?: (loading: boolean) => void;
};

const ModelViewer: React.FC<ModelViewerProps> = ({
  modelPath,
  rotationY,
  iosSrc,
}) => {
  const [_, setLoading] = useState(true);
  useEffect(() => {
    if (setLoading) {
      setLoading(true);
    }

    const modelViewer = document.querySelector("model-viewer");

    const handleModelLoad = () => {
      if (setLoading) {
        setLoading(false);
      }
    };

    if (modelViewer) {
      modelViewer.addEventListener("load", handleModelLoad);
      modelViewer.setAttribute("ios-src", iosSrc || "");
    } else {
      console.error("Failed to find model-viewer element.");
    }

    if (iosSrc) {
      setLoading(false);
    } else {
      setLoading(true);
    }

    return () => {
      if (modelViewer) {
        modelViewer.removeEventListener("load", handleModelLoad);
      }
    };
  }, [modelPath, iosSrc, setLoading]);

  return (
    <div
      className="dark:bg-black"
      style={{
        width: "100%",
        height: "70vh",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <model-viewer
        ios-src={iosSrc || undefined}
        src={modelPath}
        alt="3D model"
        autoplay
        ar
        rotation={`0 ${rotationY || 0} 0`}
        auto-rotate
        camera-controls
        style={{
          width: "100%",
          height: "100%",
          marginTop: "-40px",
        }}
      />
    </div>
  );
};

export default ModelViewer;
